<template>
  <div
    class="flex rounded-full bg-primary overflow-hidden"
    style="width: fit-content; box-shadow: 0px -1px 20px 0px #c1c1c1"
  >
    <div
      v-for="(tab, index) in tabs"
      :key="tab.value"
      class="px-2.5 py-1 flex items-center"
      :class="{
        'pl-4': index === 0,
        'pr-4': index === tabs.length - 1,
        'cursor-pointer': tab.value !== value,
        'bg-secondary': tab.value === value,
        'text-white': tab.value === value,
        underline: tab.value !== value,
        'cursor-default': tab.value === value
      }"
      @click="$emit('input', tab.value)"
    >
      {{ tab.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  components: {},
  props: {
    value: {
      type: String,
      default: "tab1"
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  data() {
    return {
      selectedTab: "tab1"
    };
  },
  created() {}
};
</script>

<style></style>
